/*
 * @Author: cyw
 * @Date: 2020-04-28 15:50:32
 * @LastEditors: CaoJ2020 CaoJian20132014@163.com
 * @LastEditTime: 2022-12-16 13:42:22.836 +08:00 Friday PM
 * @Descripttion:
 */
export default [
	/**
	 * 首页Tab我的 -> 院内宣教
 	*/
	{
		path: "/user/hospitalPreach",
		name: "hospitalPreach",
		component: resolve => require.ensure([], () => resolve(require("@/views/preachInvestigateCollect/hospital-preach")), "hospitalPreach"),
		meta: {
			title: "健康宣教"
		}
	},
	/**
	 * 首页Tab我的 -> 院内调查
 	*/
	{
		path: "/user/hospitalInvestigate",
		name: "hospitalInvestigate",
		component: resolve => require.ensure([], () => resolve(require("@/views/preachInvestigateCollect/hospital-investigate")), "hospitalInvestigate"),
		beforeEnter: (to, from, next) => {
			switch (to.query.source) {
				case 'follow':
					to.meta.title = '健康随访';
					break;
				case 'satisfaction':
					to.meta.title = '满意度调查';
					break;
				case 'klq':
					to.meta.title = '知识问卷';
					break;
				default:
					to.meta.title = '健康随访';
					break;
			}
			next();
		},
		meta: {
			title: ""
		},
	},
	/**
	 * 首页Tab我的 -> 我的收藏
 	*/
	{
		path: "/user/myCollect",
		name: "myCollect",
		component: resolve => require.ensure([], () => resolve(require("@/views/preachInvestigateCollect/my-collect")), "myCollect"),
		meta: {
			title: "我的收藏"
		}
	},
	/**
	 * 首页Tab我的 -> 个人信息
 	*/
	{
		path: "/user/personalInformation",
		name: "personalInformation",
		component: resolve => require.ensure([], () => resolve(require("@/views/preachInvestigateCollect/personal-information")), "personalInformation"),
		meta: {
			title: "个人信息"
		}
	},
	{
		path: "/home/user/userReminder",
		name: "userReminder",
		component: resolve => require.ensure([], () => resolve(require("@/views/home-user-userReminder/home-user-userReminder")), "userReminder"),
		meta: {
			title: "用药提醒"
		}
	},
	{
		path: "/home/user/userReminder/addPlans",
		name: "addPlans",
		component: resolve => require.ensure([], () => resolve(require("@/views/home-user-userReminder-addPlans/home-user-userReminder-addPlans")), "addPlans"),
		meta: {
			title: "添加提醒计划"
		}
	}
];



// WEBPACK FOOTER //
// ./src/router/preachInvestigateCollect.js